import { render, staticRenderFns } from "./task-source.vue?vue&type=template&id=d311e3e2"
import script from "./task-source.vue?vue&type=script&lang=js"
export * from "./task-source.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports